import Layout from "@/layout";
export default {
  path: "Stock",
  component: () => import("@/views/AppMain/index"),
  name: "Stock",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "门店库存",
    keepAlive: false,
    icon: "1014",
    activeIcon: "1013"
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
    {
      hidden: false,
      path: "InventoryData",
      component: () =>
        import("@/views/HeadOfficeManagement/Stock/InventoryData"),
      name: "InventoryData",
      meta: {
        title: "库存数据",
        keepAlive: true
      }
    },
    {
      hidden: false,
      path: "InventoryFlow",
      component: () =>
        import("@/views/HeadOfficeManagement/Stock/InventoryFlow"),
      name: "InventoryFlow",
      meta: {
        title: "库存流水",
        keepAlive: true
      }
    },
    {
      hidden: false,
      path: "WarehousingManagement",
      component: () =>
        import("@/views/HeadOfficeManagement/Stock/WarehousingManagement"),
      name: "WarehousingManagement",
      meta: {
        title: "入库管理",
        keepAlive: true
      }
    },
    {
      hidden: false,
      path: "OutboundManagement",
      component: () =>
        import("@/views/HeadOfficeManagement/Stock/OutboundManagement"),
      name: "OutboundManagement",
      meta: {
        title: "出库管理",
        keepAlive: true
      }
    },
    {
      hidden: false,
      path: "CommodityLossReporting",
      component: () =>
        import("@/views/HeadOfficeManagement/Stock/CommodityLossReporting"),
      name: "CommodityLossReporting",
      meta: {
        title: "商品报损",
        keepAlive: true
      }
    },
    {
      hidden: false,
      path: "CommodityTransfer",
      component: () =>
        import("@/views/HeadOfficeManagement/Stock/Transfer"),
      name: "CommodityTransfer",
      meta: {
        title: "商品调拨",
        keepAlive: true
      }
    },
    {
      hidden: true,
      path: "WarehousingManagementDetail",
      component: () =>
        import(
          "@/views/HeadOfficeManagement/Stock/WarehousingManagementDetail"
        ),
      name: "WarehousingManagementDetail",
      meta: {
        title: "入库详情",
        keepAlive: false,
        activeMenu: "/HeadOfficeManagement/Stock/WarehousingManagement"
      }
    },
    // {
    //   hidden: true,
    //   path: "WarehousingManagementAdd",
    //   component: () => import("@/views/HeadOfficeManagement/Stock/WarehousingManagementAdd"),
    //   name: "WarehousingManagementAdd",
    //   meta: {
    //     title: "新增入库",
    //     keepAlive: false,
    //     activeMenu: '/HeadOfficeManagement/Stock/WarehousingManagement'
    //   },
    // },
    {
      hidden: true,
      path: "OutboundManagementDetail",
      component: () =>
        import("@/views/HeadOfficeManagement/Stock/OutboundManagementDetail"),
      name: "OutboundManagementDetail",
      meta: {
        title: "出库详情",
        keepAlive: false,
        activeMenu: "/HeadOfficeManagement/Stock/OutboundManagement"
      }
    },
    // {
    //   hidden: true,
    //   path: "OutboundManagementAdd",
    //   component: () => import("@/views/HeadOfficeManagement/Stock/OutboundManagementAdd"),
    //   name: "OutboundManagementAdd",
    //   meta: {
    //     title: "新增出库",
    //     keepAlive: false,
    //     activeMenu: '/HeadOfficeManagement/Stock/OutboundManagement'
    //   },
    // },
    {
      hidden: true,
      path: "CommodityLossReportingDetail",
      component: () =>
        import(
          "@/views/HeadOfficeManagement/Stock/CommodityLossReportingDetail"
        ),
      name: "CommodityLossReportingDetail",
      meta: {
        title: "商品报损详情",
        keepAlive: false,
        activeMenu: "/HeadOfficeManagement/Stock/CommodityLossReporting"
      }
    },
    {
      hidden: true,
      path: "CommodityTransferDetail",
      component: () =>
        import("@/views/HeadOfficeManagement/Stock/TransferDetail"),
      name: "CommodityTransferDetail",
      meta: {
        title: "库存调拨详情",
        keepAlive: false
      }
    },
    // {
    //   hidden: true,
    //   path: "CommodityLossReportingAdd",
    //   component: () => import("@/views/HeadOfficeManagement/Stock/CommodityLossReportingAdd"),
    //   name: "CommodityLossReportingAdd",
    //   meta: {
    //     title: "新增报损",
    //     keepAlive: false,
    //     activeMenu: '/HeadOfficeManagement/Stock/CommodityLossReporting'
    //   },
    // },
    {
      hidden: false,
      path: "InventoryCount",
      component: () => import("@/views/AppMain/index"),
      name: "InventoryCount",
      alwaysShow: true,
      meta: {
        title: "库存盘点",
        keepAlive: true
      },
      children: [
        {
          hidden: false,
          path: "InventoryCount",
          component: () =>
            import("@/views/HeadOfficeManagement/Stock/InventoryCount"),
          name: "InventoryCount",
          meta: {
            title: "库存盘点",
            keepAlive: true
          }
        },
        {
          hidden: true,
          path: "InventoryCountDetail",
          component: () =>
            import("@/views/HeadOfficeManagement/Stock/InventoryCountDetail"),
          name: "InventoryCountDetail",
          meta: {
            title: "盘点详情",
            keepAlive: false,
            activeMenu: "/HeadOfficeManagement/Stock/InventoryCount/InventoryCount"
          }
        },
        {
          hidden: false,
          path: "InventoryPlan",
          component: () =>
            import("@/views/HeadOfficeManagement/Stock/InventoryPlan"),
          name: "InventoryPlan",
          meta: {
            title: "盘点计划",
            keepAlive: true,
            activeMenu: "/HeadOfficeManagement/Stock/InventoryPlan"
          }},
        {
          hidden: true,
          path: "InventoryPlanAdd",
          component: () =>
            import("@/views/HeadOfficeManagement/Stock/InventoryPlanAdd"),
          name: "InventoryPlanAdd",
          meta: {
            title: "新建盘点计划",
            keepAlive: false,
            activeMenu: "/HeadOfficeManagement/Stock/InventoryPlan"
          }
        },
        {
          hidden: true,
          path: "InventoryPlanDetail",
          component: () =>
            import(
              "@/views/HeadOfficeManagement/Stock/InventoryPlanDetail"
            ),
          name: "InventoryPlanDetail",
          meta: {
            title: "盘点计划详情",
            keepAlive: false,
            activeMenu: "/HeadOfficeManagement/Stock/InventoryPlan"
          }
        },
        {
          hidden: false,
          path: "InventoryRecord",
          component: () =>
            import("@/views/HeadOfficeManagement/Stock/InventoryRecord"),
          name: "InventoryRecord",
          meta: {
            title: "盘点库存记录",
            keepAlive: true,
            activeMenu: "/HeadOfficeManagement/Stock/InventoryRecord"
          }
        },
      ]
    },
    // {
    //   hidden: true,
    //   path: "InventoryCountAdd",
    //   component: () => import("@/views/HeadOfficeManagement/Stock/InventoryCountAdd"),
    //   name: "InventoryCountAdd",
    //   meta: {
    //     title: "新增盘点",
    //     keepAlive: false,
    //     activeMenu: '/HeadOfficeManagement/Stock/InventoryCount'
    //   },
    // },
    {
      hidden: false,
      path: "GoodsOut",
      component: () => import("@/views/HeadOfficeManagement/Stock/GoodsOut"),
      name: "GoodsOut",
      meta: {
        title: "商品报溢",
        keepAlive: true
      }
    },
    {
      hidden: true,
      path: "GoodsOutDetail",
      component: () =>
        import("@/views/HeadOfficeManagement/Stock/GoodsOutDetail"),
      name: "GoodsOutDetail",
      meta: {
        title: "详情",
        keepAlive: false,
        activeMenu: "/HeadOfficeManagement/Stock/GoodsOut"
      }
    },
    {
      hidden: false,
      path: "ReturnPolicy",
      component: () => import("@/views/HeadOfficeManagement/Stock/ReturnPolicy"),
      name: "ReturnPolicy",
      meta: {
        title: "商品退货",
        keepAlive: true,
      },
    },
    {
      hidden: true,
      path: "ReturnPolicyDetail",
      component: () => import("@/views/HeadOfficeManagement/Stock/ReturnPolicyDetail"),
      name: "ReturnPolicyDetail",
      meta: {
        title: "退货单详情",
        keepAlive: false,
        activeMenu: "/HeadOfficeManagement/Stock/ReturnPolicy"
      },
    },
  ]
};
